var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialSymbolsQrCode2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.6667 140V126.667H100V140H86.6667ZM73.3333 126.667V93.3333H86.6667V126.667H73.3333ZM126.667 106.667V80H140V106.667H126.667ZM113.333 80V66.6667H126.667V80H113.333ZM33.3333 93.3333V80H46.6667V93.3333H33.3333ZM20 80V66.6667H33.3333V80H20ZM80 33.3333V20H93.3333V33.3333H80ZM30 50H50V30H30V50ZM20 60V20H60V60H20ZM30 130H50V110H30V130ZM20 140V100H60V140H20ZM110 50H130V30H110V50ZM100 60V20H140V60H100ZM113.333 140V120H100V106.667H126.667V126.667H140V140H113.333ZM86.6667 93.3333V80H113.333V93.3333H86.6667ZM60 93.3333V80H46.6667V66.6667H86.6667V80H73.3333V93.3333H60ZM66.6667 60V33.3333H80V46.6667H93.3333V60H66.6667ZM35 45V35H45V45H35ZM35 125V115H45V125H35ZM115 45V35H125V45H115Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialSymbolsQrCode2);
export default __webpack_public_path__ + "static/media/material-symbols_qr-code-2.f1932a25012fc4c3858965075585f57d.svg";
export { ForwardRef as ReactComponent };